import script from "./sw-item-editor-link.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor-link.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor-link.vue?vue&type=style&index=0&id=e3d7dc9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3d7dc9e"]])

export default __exports__